import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { SignaturePadModule } from 'angular2-signaturepad';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { NgxDaterangepickerMd,DaterangepickerComponent } from 'ngx-daterangepicker-material';
import { MyDatePickerModule } from 'mydatepicker';

//Component
import { AddUpdateTaskComponent } from '../pages/addupdatetask/addupdatetask.component';
import { PeopleContactsComponent } from '../pages/peoplecontacts/peoplecontacts.component';
import { NewfuelsComponent } from './../pages/fuel/newfuels/newfuels.component';
import { TyreComponent } from '../pages/fleetassets/tyre/tyre.component';
import { OtherCostComponent } from '../pages/fleetassets/othercost/othercost.component';
import { IncidentsComponent } from './../pages/incidents/incidents.component';
import { BillTypeCreateComponent } from '../pages/bills/billtypecreate/billtypecreate.component';
import { BillPaymentsComponent } from '../pages/bills/billpayments/billpayments.component';
import { BillImportExpenseRecord } from '../pages/bills/billimportexpenserecord/billimportexpenserecord.component';
import { ServiceComponent } from './../pages/maintenance/service/service.component';
import { RepairComponent } from './../pages/maintenance/repair/repair.component';
import { RnDReportComponent } from './../pages/maintenance/rndreport/rndreport.component';
import { NotificationsSettingsComponent } from './../pages/settings/notificationssettings/notificationssettings.component';
import { InductionsComponent } from './../pages/inductions/inductions.component';
import { UserFilesComponent } from './../pages/userfiles/userfiles.component';

//Module
import { ImageUploaderModule } from './../pages/control/image-uploader/image-uploader.module';
import { PipesModule } from '../theme/pipes/pipes.module';
import { FileUploaderModule } from './../pages/control/file-uploader/file-uploader.module';
import { MultipleImageUploaderModule } from '../pages/control/multiple-image-uploader/multiple-image-uploader.module';
import { FleetPairingService } from '../services/fleet-pairing.service';
import { FleetService } from '../services/fleet.service';


@NgModule({
    imports: [
        CommonModule,
        NgxLoadingModule,   
        NgbModule,
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        PipesModule,
        FileUploaderModule,
        NgxDatatableModule,
        ImageUploaderModule,
        SignaturePadModule,
        MultipleImageUploaderModule,
        NgxLoadingModule.forRoot({
            animationType: ngxLoadingAnimationTypes.threeBounce,
            backdropBackgroundColour: 'rgba(0, 0, 0, 0)',
            backdropBorderRadius: '4px',
            primaryColour: '#666666',
            secondaryColour: '#666666',
            tertiaryColour: '#666666'
          }),
        NgxDaterangepickerMd.forRoot(),
        MyDatePickerModule
     ],
    declarations: [
        ServiceComponent,
        AddUpdateTaskComponent,
        PeopleContactsComponent,
        NewfuelsComponent,
        TyreComponent,
        OtherCostComponent,
        RnDReportComponent,
        RepairComponent,
        IncidentsComponent,
        BillTypeCreateComponent,
        BillPaymentsComponent,
        BillImportExpenseRecord,
        NotificationsSettingsComponent,
        InductionsComponent,
        UserFilesComponent
    ],
    exports: [
        ServiceComponent,
        AddUpdateTaskComponent,
        PeopleContactsComponent,
        NewfuelsComponent,
        TyreComponent,
        OtherCostComponent,
        RnDReportComponent,
        RepairComponent,
        IncidentsComponent,
        BillTypeCreateComponent,
        BillPaymentsComponent,
        BillImportExpenseRecord,
        NotificationsSettingsComponent,
        InductionsComponent,
        UserFilesComponent,
        NgxDatatableModule,
        ReactiveFormsModule,
        CommonModule,
        NgbModule,
        PipesModule
    ],
    providers: [FleetService, FleetPairingService],
    entryComponents: [DaterangepickerComponent]
  
})
export class SharedModule {}